import './Rodape.css'

function Rodape () {
    return(
        <footer className='footer'>
            <div className='footer-block'>
                <h2>Challenge by <a href='https://www.frontendmentor.io/home' target='_blank'>Frontend Mentor</a>. Coded by <a href='https://github.com/KauanArrudaMachado380' target='_blank'>Kauan A. Machado</a> Here.</h2>
            </div>
        </footer>
    )
}

export default Rodape;